module.exports = __webpack_public_path__ + "static/media/justModal.6749d855.jpg";